import { faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import avtar from "../../../assets/images/defaultavtarimg.svg";
import React from "react";

type AvatarSize = "xxxs" | "xxs" | "xs" | "sm" | "md" | "lg" | "xl";

interface DefaultAvatarProps {
  userId: string;
  displayName?: string; // Optional, fallback to userId
  size?: AvatarSize; // Optional size from predefined set
}

const sizeMap: Record<AvatarSize, string> = {
  xxxs: "w-6 h-6", // 24px
  xxs: "w-6 h-6",
  xs: "w-10 h-10", // 40px
  sm: "w-12 h-12", // 48px
  md: "w-20 h-20", // 80px
  lg: "w-32 h-32", // 128px
  xl: "w-48 h-48", // 192px
};

const getInitials = (name: string): string => {
  if (!name || name.trim().length === 0) return "?";
  const parts = name.trim().split(" ");
  if (parts.length === 1) return parts[0][0]?.toUpperCase() ?? "?";
  return (parts[0][0] + (parts[1]?.[0] || '')).toUpperCase();
};

const DefaultAvatar: React.FC<DefaultAvatarProps> = ({
  userId,
  displayName,
  size = "md",
}) => {
  // Check if userId or displayName are undefined or null
  const safeUserId = userId ?? "";
  const safeDisplayName = displayName ?? null;
  
  const nameToUse = safeDisplayName || safeUserId || "User";
  const initials = getInitials(nameToUse);
  const sizeClasses = sizeMap[size] || sizeMap.md;

  return (
    <div
      title={nameToUse}
    >
      {/* {initials} */}
      <img
        className={`rounded-full ${sizeClasses} object-cover text-lg flex items-center justify-center align-middle`}
        src={avtar}
        alt="profile"
        onError={(e) => {
          e.currentTarget.onerror = null;
          e.currentTarget.src = avtar;
        }}
      />
    </div>
  );
};

export default DefaultAvatar;
